var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:{ 'mb-8': _vm.extraSpace, 'pt-2': _vm.topSpace }},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","xl":_vm.xlSize}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }